import { toBaseProperties } from '@members/analytics';

export const trackViewedBannerCard = (
  browseCategory: string,
  bannerCardName: string,
) => ({
  event: 'Viewed Banner Card',
  ...toBaseProperties(),
  browseCategory,
  bannerCardName,
});
